export default "__VITE_ASSET__CFaRkykl__"